import React, { Component } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Redirect } from 'react-router-dom'
import axios from 'axios';
import plan from '../../../assets/img/premium/plan.svg'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Trans } from "react-i18next";   
import "../../../config/i18n";
import { withTranslation } from "react-i18next";

class SelectPlan extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedOption: '',
            paymentmodal:false,
            api_url:localStorage.getItem('api_url'),
            itemss: [], premium_type: '', permium_days: '',
            coupon_type: 'premium',
            nopremiumplan: '',
            permium_superlikeCount: '',
            permium_boostCount: '',
            permium_resetCount: ''
        };
        
    }

    componentDidMount() {
        var premiumlist = new FormData();
        premiumlist.set('platform', 'web');
        premiumlist.set('language', this.state.langKey); 
        axios({
            method: 'post',
            url: this.state.api_url+'premiumlistweb', 
            data: premiumlist,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            const data = res.data;
            this.setState({
                itemss: data.result,
                selected_premium: data.result[0].id,
                premium_price: data.result[0].price,   
                currency: data.currency,
                payment: data.payment,
                license_key: data.license_key, 
            });
            localStorage.setItem('selected_premium',JSON.stringify(this.state.selected_premium));
            localStorage.setItem('premium_price',JSON.stringify(this.state.premium_price));
            localStorage.setItem('currency',JSON.stringify(this.state.currency));
        }).catch(error => console.error('Error fetching premium list:', error));
    }

    componentDidUpdate(prevProps) {
        if (prevProps.premiumType !== this.props.premiumType) {
            console.log("Premium type changed to:", this.props.premiumType);
            let premium_type;    
            if (this.props.premiumType === 'gold') {
                premium_type = 'Kaba Gold';
            } else if (this.props.premiumType === 'silver') {
                premium_type = 'Kaba Silver';
            } else {
                premium_type = 'Kaba Platinum';
            }
            this.setState({ premium_type: premium_type });
        }
    }

    handleItemClick(index) {
        var premiumlist = new FormData();
        premiumlist.set('premiumid', index);
        premiumlist.set('language', this.state.langKey);  
        axios({
            method: 'post',
            url: this.state.api_url+'premiumid',
            data: premiumlist,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            const data = res.data;
            this.setState({
                premium_price: data.result.price,
                permium_superlikeCount: data.result.superlikecount, 
                permium_boostCount: data.result.boostcount,
                permium_resetCount: data.result.resetcount, 
                permium_days: data.result.days, 
                permium_type: data.result.type, 
                original_price: data.result.price,
                discount_price: 0,
            });
            localStorage.setItem('selected_premium',JSON.stringify(index));
            localStorage.setItem('premium_price',JSON.stringify(data.result.price)); 
            localStorage.setItem('discount_id',JSON.stringify(0)); 
            localStorage.setItem('original_price',JSON.stringify(data.result.price));
            localStorage.setItem('discount_price',JSON.stringify(0));
        });
    }

    handleOptionChange = (packageId) => {
        this.setState({
            selectedOption: packageId
        });
        this.handleItemClick(packageId);
    };

    handlePaymentOpenModal = () => {
        if(this.state.selectedOption === null || this.state.selectedOption === '') {
            this.setState({ nopremiumplan: 'Please select any one plan' });
            setTimeout(() => {
                this.setState({
                    nopremiumplan: ''
                });
            }, 2000);
        } else {
            this.props.handleClose();
            this.setState({ couponmodal: true });
        }
    }

    render() {
        if (this.state.couponmodal) {
            const premiumPath = `/coupon/${this.state.coupon_type}`;
            return <Redirect to={premiumPath} />;
        }

        const checkedRadioStyle = {
            color: '#fff',
        };

        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            swipe: true,
            touchMove: true,
            draggable: true,
            focusOnSelect: true,
            autoplay:true
        };

        const { premium_type } = this.props;
    
        return (
            <>
                <div className="">
                    <Modal className="modal_div joinplan_modal" show={this.props.showModal} onHide={this.props.handleClose} centered>
                        <Modal.Header>
                            <Modal.Title><Trans i18nKey="Join">Join</Trans> {this.state.premium_type}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="religion_modal selectplan_height">
                            <div className=''>
                                <div className="">
                                    <Slider {...settings} className='selectplan_slider'>
                                        <div>
                                            <img src={plan} alt="img" />
                                            <div className='selectplan_content'>
                                                <h4>{(this.state.permium_superlikeCount !== '' && this.state.permium_superlikeCount !== 0) ? this.state.permium_superlikeCount : ''} <Trans i18nKey="Super Likes">Super Likes</Trans></h4>
                                                <p><Trans i18nKey="Express your interest in someone with a Super Like, making it clear you really like them.">Express your interest in someone with a Super Like, making it clear you really like them.</Trans></p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src={plan} alt="img" />
                                            <div className='selectplan_content'>
                                                <h4>{(this.state.permium_boostCount !== '' && this.state.permium_boostCount !== 0) ? this.state.permium_boostCount : ''} <Trans i18nKey="Boost">Boost</Trans></h4>
                                                <p><Trans i18nKey="Become the top profile in your area for 30 minutes to enhance your visibility and increase your matches. Continue swiping to see the difference.">Become the top profile in your area for 30 minutes to enhance your visibility and increase your matches. Continue swiping to see the difference.</Trans></p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src={plan} alt="img" />
                                            <div className='selectplan_content'>
                                                <h4><Trans i18nKey="Change Your Location">Change Your Location</Trans></h4>
                                                <p><Trans i18nKey="Connect and chat with people worldwide by selecting a new city. Expand your search and find matches beyond your current location.">Connect and chat with people worldwide by selecting a new city. Expand your search and find matches beyond your current location.</Trans></p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src={plan} alt="img" />
                                            <div className='selectplan_content'>
                                                <h4><Trans i18nKey="Unlimited Likes">Unlimited Likes</Trans></h4>
                                                <p><Trans i18nKey="Never run out of likes. With Unlimited Likes, you have the freedom to swipe right as much as you please.">Never run out of likes. With Unlimited Likes, you have the freedom to swipe right as much as you please.</Trans></p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src={plan} alt="img" />
                                            <div className='selectplan_content'>
                                                <h4><Trans i18nKey="Rewind">Rewind</Trans></h4>
                                                <p><Trans i18nKey="Mistakenly swiped left or right? Rewind allows you to undo your last action, ensuring you don't miss out on a potential match.">Mistakenly swiped left or right? Rewind allows you to undo your last action, ensuring you don't miss out on a potential match.</Trans></p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src={plan} alt="img" />
                                            <div className='selectplan_content'>
                                                <h4><Trans i18nKey="See Who Likes You">See Who Likes You</Trans></h4>
                                                <p><Trans i18nKey="With the 'Likes You' feature, discover who has shown interest in you before making your swipe decision.">With the 'Likes You' feature, discover who has shown interest in you before making your swipe decision.</Trans></p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src={plan} alt="img" />
                                            <div className='selectplan_content'>
                                                <h4><Trans i18nKey="Profile Privacy Plus">Profile Privacy Plus</Trans></h4>
                                                <p><Trans i18nKey="Enjoy ultimate privacy and control. Go invisible, hide your age, turn off ads, and customise your feed and notifications. Your profile, your way">Enjoy ultimate privacy and control. Go invisible, hide your age, turn off ads, and customise your feed and notifications. Your profile, your way</Trans></p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src={plan} alt="img" />
                                            <div className='selectplan_content'>
                                                <h4><Trans i18nKey="See who visited your profile">See who visited your profile</Trans></h4>
                                                <p><Trans i18nKey="Curious about who's been checking you out? Our visitor feature reveals who has viewed your profile.">Curious about who's been checking you out? Our visitor feature reveals who has viewed your profile.</Trans></p>
                                            </div>
                                        </div>
                                        <div>
                                            <img src={plan} alt="img" />
                                            <div className='selectplan_content'>
                                                <h4><Trans i18nKey="Turn Off Ads">Turn Off Ads</Trans></h4>
                                                <p><Trans i18nKey="Enjoy uninterrupted swiping and a smoother app experience without any ads.">Enjoy uninterrupted swiping and a smoother app experience without any ads.</Trans></p>
                                            </div>
                                        </div>
                                        {premium_type !== "Kaba Silver" && (
                                            <div>
                                                <img src={plan} alt="img" />
                                                <div className='selectplan_content'>
                                                    <h4>{(this.state.permium_resetCount !== '' && this.state.permium_resetCount !== 0) ? this.state.permium_resetCount : ''} <Trans i18nKey="Swipe Reset">Swipe Reset</Trans></h4>
                                                    <p><Trans i18nKey="Rewind and Revisit profiles you've swiped left on. Never miss a chance at a connection again.">Rewind and Revisit profiles you've swiped left on. Never miss a chance at a connection again.</Trans></p>
                                                </div>
                                            </div>
                                        )}
                                    </Slider>
                                </div>
                                <div className='selectplan_select '>
                                    {
                                        this.state.itemss
                                            .filter(item => item.premiumtype === this.state.premium_type) // Filter items based on selected premium type
                                            .map((item, index) => ( // Ensure parameters are correctly defined
                                                <Form.Group key={index} controlId={`premiumOption-${index}`} className={`selectplanformgrop language_formgroup selectplan_formgroup ${this.state.selectedOption === item.id ? 'common_language' : ''}`}>
                                                    <Form.Check.Label htmlFor={`radio-${item.id}`}>
                                                        <span style={this.state.selectedOption === item.id ? checkedRadioStyle : null}>
                                                            {this.state.currency}{item.price} for {item.days} {item.type} {/* Use item properties dynamically */}
                                                        </span>
                                                    </Form.Check.Label>
                                                    <Form.Check
                                                        type="radio"
                                                        id={`radio-${item.id}`} // Ensure the ID is unique and dynamic
                                                        name="radioGroup"
                                                        value={item.id} // Use item ID to track selected option
                                                        checked={this.state.selectedOption === item.id } // Check if the current item is selected
                                                        onChange={() => this.handleOptionChange(item.id)} // Assume handleOptionChange is adjusted to accept an item ID
                                                    />
                                                </Form.Group>
                                            ))
                                    }
                                </div>
                            </div>
                        </Modal.Body>
                        <div className="errorMsg" style={{ paddingLeft: "135px" }}>{this.state.nopremiumplan}</div>
                        <Modal.Footer className="forgot_button_plr">
                            <Button className='button_primary' onClick={this.handlePaymentOpenModal}>
                            <Trans i18nKey="BUY">BUY</Trans> {this.state.permium_days} {this.state.permium_type} <Trans i18nKey="PLAN">PLAN</Trans>
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
                
            </>
        );
    }
}

export default SelectPlan;
